import { create } from "zustand";

export const useContactStore = create((set) => ({
  contactList: [],
  setContactList: (contacts) => set({ contactList: contacts }),
}));
